module.exports = __webpack_public_path__ + "media/dashboard/assets/images/bank/permata-logo-c8423fad163d465d763746ab60203676.png";